export class QuestionAnswerModel {
  id: number;
  title: string;
  body: string;
  type: string;
}
